import type { Router } from "@/__main__/router.mjs";
import { APP_SCROLLER } from "@/app/constants.mjs";
import globals from "@/util/global-whitelist.mjs";

let previousPath: string;

// Handle auto scrolling to top on route change 🥴
export default function scrollOnRouteChange(router: Router, event: string) {
  router.events.on(event, () => {
    const currentPath = router.route?.currentPath;
    if (!currentPath || currentPath === previousPath) return;
    previousPath = currentPath;

    const element = globals.document.querySelector(`.${APP_SCROLLER}`);
    if (!element?.scrollTo) return;
    element.scrollTo({
      top: 0,
      left: 0,
    });
  });
}
